<template>
  <el-form ref="form" :model="formData" :rules="rules">
    <el-row :gutter="20">
      <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
        <el-form-item :label="$l('form_label_attribute_type')||'属性类型'" prop="resAttributeType">
          <el-input v-model="formData.resAttributeType" disabled size="medium"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
        <el-form-item :label="$l('form_label_status')||'有效状态'" prop="resAttributeStatus">
          <el-radio-group
            size="medium"
            style="width: 100%;"
            disabled
            v-model="formData.resAttributeStatus"
          >
            <el-radio label="Y">{{$l('form_radio_label_status_valid')||'有效'}}</el-radio>
            <el-radio label="N">{{$l('form_radio_label_status_invalid')||'无效'}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
        <el-form-item :label="$l('form_label_name_cn')||'中文名称'" prop="resAttributeName">
          <el-input
            v-model="formData.resAttributeName"
            clearable
            size="medium"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
        <el-form-item :label="$l('form_label_name_en')||'英文名称'" prop="resAttributeNameEn">
          <el-input
            v-model="formData.resAttributeNameEn"
            clearable
            size="medium"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
        <el-form-item :label="$l('form_label_remarks')||'属性说明'" prop="resAttributeDescription">
          <el-input
            v-model="formData.resAttributeDescription"
            clearable
            size="medium"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col v-if="formData.resAttributeCode">
        <div style="font-size: 14px; color: #606266;">
          <span>Create：{{formData.createByName}} at {{formData.createDate}}</span>
          <el-divider direction="vertical"></el-divider>
          <span>Modify：{{formData.modifyByName}} at {{formData.modifyDate}}</span>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    params:{
      default: null,
      type: Object
    }
  },
  data() {
    return {
      disabled: false,
      disabledEdit: false,
      formData: {
        resAttributeCode: "",
        resAttributeType: "",
        resAttributeStatus: "Y",
        resAttributeName: "",
        resAttributeNameEn: "",
        resAttributeDescription: "",
        createByName: "",
        createDate: "",
        modifyByName: "",
        modifyDate: "",
      },
      rules: {
        resAttributeType: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_type") || "请输入属性类型",
            trigger: "blur",
          },
        ],
        resAttributeName: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_name") || "请输入中文名称",
            trigger: "blur",
          },
        ],
        resAttributeNameEn: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_name_en") ||
              "请输入英文名称",
            trigger: "blur",
          },
        ],
        resAttributeStatus: [
          {
            required: true,
            message: this.$l("form_rule_message_status") || "请选择有效状态",
            trigger: "blur",
          },
        ],
        resAttributeDescription: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_desc") || "请输入属性说明",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, val = "") {
      this.init();
      if (ref !== "add") {
        let param = { resAttributeCode: val };
        this.$api.detailResearchDictionaryApi(param).then((res) => {
          this.formData = res.body;
        });
        // 控制组件不可编辑
        if (ref === "detail") {
          this.disabled = true;
          this.disabledEdit = true;
        }
        if (ref === "edit") {
          this.disabled = false;
          this.disabledEdit = true;
        }
      } else {
        this.formData.resAttributeType = this.params.resAttributeType
      }
    },
    // 保存数据
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.saveResearchDictionaryApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_save_ok") || "保存成功",
              type: "success",
            });
            // 通知父组件保存成功
            this.$emit("success");
          });
        } else {
          return false;
        }
      });
    },
    // 初始化表单数据
    init() {
      this.disabled = false;
      this.disabledEdit = false;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
        this.formData = {
          resAttributeCode: "",
          resAttributeType: "",
          resAttributeStatus: "Y",
          resAttributeName: "",
          resAttributeNameEn: "",
          resAttributeDescription: "",
          createByName: "",
          createDate: "",
          modifyByName: "",
          modifyDate: ""
        }
      }
    },
  },
};
</script>
